import {label} from "@/class/label";

export class area extends label{
    
    objectType = "area";
    parentObjectType = "interactive_image";
    
    data = [
        {name: "points", type: Array, default: []},
    ]
    
    constructor() {
        super();
        this.init();
    }
    
}